<template>
    <div class="docs" v-html="documentation">
    </div>  
</template>

<style scoped src="@/assets/documentation.css">
</style>

<script>
import routes from '@/assets/user/pages/routes.js' 
export default {
    name: 'UserPage',
    props: {
        file_path : String
    },
    data() {
        return {
            documentation: "",
        }
    },
    mounted() {
        this.documentation = routes[this.file_path];
    }
}
</script>